import React from "react";

const HFNLoading = ({ message = "" }) => {
  return (
    <div className="lds-roller-wrapper">
      <div className="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>

      {message && <p className="lds-text">{message}</p>}
    </div>
  );
};

export default HFNLoading;
